'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addError = addError;
exports.addWarning = addWarning;
exports.addSuccess = addSuccess;
exports.addInfo = addInfo;
exports.addApocalypse = addApocalypse;
exports.addFlashMessageOfType = addFlashMessageOfType;
exports.resetNextFlashMessageId = resetNextFlashMessageId;

var _index = require('./index');

/**
 * Adds a flash message of the type 'ERROR' on the flash message queue
 * in Redux.
 * 
 * @param {FlashMessageConfig} { text, onClick, data } 
 */
function addError(_ref) {
  var text = _ref.text,
      onClick = _ref.onClick,
      data = _ref.data;

  addFlashMessageOfType('ERROR', 10000, text, onClick, data);
}

/**
 * Adds a flash message of the type 'WARNING' on the flash message queue
 * in Redux. After 7000 milliseconds it will automatically be removed
 * from the queue.
 * 
 * @param {FlashMessageConfig} { text, onClick, data } 
 */


function addWarning(_ref2) {
  var text = _ref2.text,
      onClick = _ref2.onClick,
      data = _ref2.data;

  addFlashMessageOfType('WARNING', 7000, text, onClick, data);
}

/**
 * Adds a flash message of the type 'SUCCESS' on the flash message queue
 * in Redux. After 2000 milliseconds it will automatically be removed
 * from the queue.
 * 
 * @param {FlashMessageConfig} { text, onClick, data } 
 */
function addSuccess(_ref3) {
  var text = _ref3.text,
      onClick = _ref3.onClick,
      data = _ref3.data;

  addFlashMessageOfType('SUCCESS', 2000, text, onClick, data);
}

/**
 * Adds a flash message of the type 'INFO' on the flash message queue
 * in Redux. After 5000 milliseconds it will automatically be removed
 * from the queue.
 * 
 * @param {FlashMessageConfig} { text, onClick, data } 
 */
function addInfo(_ref4) {
  var text = _ref4.text,
      onClick = _ref4.onClick,
      data = _ref4.data;

  addFlashMessageOfType('INFO', 5000, text, onClick, data);
}

/**
 * Adds a flash message of the type 'APOCALYPSE' on the flash message queue
 * in Redux. This message is never removed from the queue automatically.
 * 
 * @param {FlashMessageConfig} { text, onClick, data } 
 */
function addApocalypse(_ref5) {
  var text = _ref5.text,
      onClick = _ref5.onClick,
      data = _ref5.data;

  addFlashMessageOfType('APOCALYPSE', false, text, onClick, data);
}

var nextFlashMessageId = 1;

/**
 * Adds a FlashMessage to the Redux Store and removes it after the
 * duration, if the duration is not false.
 *
 * @param type The type of message that is added
 * @param duration How long the message should stay in the Redux store. False for when it never should be removed.
 * @param text The text to render inside the message
 * @param {function} onClick The callback which will be executed when the flash message is clicked, empty by default.
 * @param data The extra data which can be passed to the renderer of the flash message.
 */
function addFlashMessageOfType(type, duration, text) {
  var onClick = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : noop;
  var data = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};

  var dispatch = (0, _index.getConfig)().dispatch;

  var id = nextFlashMessageId;

  var flashMessage = { id: id, type: type, duration: duration, text: text, onClick: onClick, data: data };

  dispatch((0, _index.addFlashMessage)(flashMessage));

  if (duration !== false) {
    setTimeout(function () {
      dispatch((0, _index.removeFlashMessage)(id));
    }, duration);
  }

  nextFlashMessageId += 1;
}

// This function does not do anything.
function noop() {}

// This export is purely for unit testing
function resetNextFlashMessageId() {
  nextFlashMessageId = 1;
}